<template>
    <div class="follow">
        <a href="https://www.facebook.com/LowellMilkenCenter" target="_blank" class="facebook"><span class="uk-icon" uk-icon="facebook" /></a>
        <a href="https://twitter.com/LowellMilkenCtr" target="_blank" class="twitter"><span class="uk-icon" uk-icon="twitter" /></a>
        <a href="http://www.youtube.com/user/LowellMilkenCtr" target="_blank" class="youtube"><span class="uk-icon" uk-icon="youtube" /></a>
        <a href="https://www.instagram.com/lowellmilkenctr" class="instagram" target="_blank"><span class="uk-icon" uk-icon="instagram" /></a>
    </div>
</template>
